import { rpc } from './ws';

export interface Me {
  id: string;
  nickname: string | null;
  email: string | null;
  emailVerified: boolean;
  pendingEmail: string | null;
  language: string;
  avatarUrl: string | null;
  pinSet: boolean;
  biometricEnabled: boolean;
}

// The `token` parameter is retained for call-site compatibility (the connection is
// authenticated globally by the WebSocket, so it is unused here).

export const fetchMe = (_token: string) => rpc<{ user: Me }>('me.get').then((r) => r.user);

export const patchMe = (_token: string, body: { language?: string; nickname?: string }) =>
  rpc<{ user: Me }>('me.patch', body).then((r) => r.user);

export const startEmail = (_token: string, email: string) =>
  rpc<{ ok: boolean; sent: boolean }>('me.emailStart', { email });

export const verifyEmail = (_token: string, code: string) =>
  rpc<{ user: Me }>('me.emailVerify', { code }).then((r) => r.user);

export const setPinApi = (_token: string, pin: string, currentPin?: string) =>
  rpc<{ ok: boolean; pinSet: boolean }>('me.setPin', { pin, currentPin });

export const removePinApi = (_token: string, pin: string) =>
  rpc<{ ok: boolean; pinSet: boolean }>('me.removePin', { pin });

export const patchBiometric = (_token: string, enabled: boolean) =>
  rpc<{ ok: boolean; biometricEnabled: boolean }>('me.setBiometric', { enabled });

export const reauth = (_token: string, method: 'pin' | 'biometric', pin?: string) =>
  rpc<{ token: string; expiresIn: number }>('me.reauth', { method, pin });

export const getSeedKey = (_token: string, reauthToken?: string) =>
  rpc<{ key: string }>('me.getSeedKey', { reauthToken });

export const resetWalletApi = (_token: string, reauthToken?: string) =>
  rpc<{ ok: boolean }>('me.resetWallet', { reauthToken });
